<template>
  <div>
    <top-bar voltar="admin"/>
    <menu-dash/>
    <div class="w3-main" style="margin-left:300px;margin-top:50px;">
      <header class="w3-container w3-cell-row w3-small" style="padding-top:22px">
        <button class="w3-button primary w3-right w3-round" style="margin-right: 12px" @click="limparSearch()">Limpar Filtros</button>
        <router-link to="/admin/colaboradores/cadastrar" class="w3-button primary w3-right w3-round" style="margin-right: 12px"><i class="fa fa-user-plus"></i> Cadastrar</router-link>
        <h6><b>Colaboradores</b></h6>
      </header>
      <div class="w3-panel">
        <div style="margin: 0 -8px">
          <div class="w3-card w3-round w3-white w3-small w3-padding-16">
            <div class="w3-row-padding">
              <div class="w3-col l6 w3-margin-top">
                <label><b>Nome</b></label>
                <input type="text" class="w3-input w3-border" placeholder="Nome do colaborador" v-model="pesquisa.nome" @change="buscarColaboradores(1)">
              </div>
              <div class="w3-col l3 w3-margin-top">
                <label><b>Usuário</b></label>
                <input type="text" class="w3-input w3-border" placeholder="Usuário do colaborador" v-model="pesquisa.usuario" @change="buscarColaboradores(1)">
              </div>
              <div class="w3-col l3 w3-margin-top">
                <label><b>Função</b></label>
                <select class="w3-select w3-border w3-white" v-model="pesquisa.funcao" @change="buscarColaboradores(1)">
                  <option value="">Todas</option>
                  <option v-for="f in funcoes" :value="f.id_funcao">{{f.nome_funcao}}</option>
                </select>
              </div>
            </div>
          </div>
          <br>
          <div class="w3-card">
            <div class="w3-responsive w3-white table-produto">
              <table class="w3-table w3-hoverable w3-bordered w3-centered w3-small">
                <thead>
                <tr class="primary">
                  <th style='width:5%'><i class="fa fa-user"></i></th>
                  <th class="w3-left-align" style='width:50%'>Nome</th>
                  <th style='width:25%'>Usuário</th>
                  <th style='width:25%'>Função</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="c in colaboradores" @click="$router.push('/admin/colaboradores/' + c.id_usuario)">
                  <td><i class="fa fa-user"></i></td>
                  <td class="w3-left-align">{{c.nome}}</td>
                  <td>{{c.usuario}}</td>
                  <td>{{c.nome_funcao}}</td>
                </tr>
                </tbody>
              </table>
              <div class="w3-display-middle w3-center" v-show="naoEcontrado">
                <div>
                  <h2><i class="far fa-frown"></i></h2>
                  <span class="w3-small">Nenhum colaborador encontrado</span>
                </div>
              </div>
            </div>
            <div class="w3-bar w3-border">
              <button @click="buscarCaixas(--page)" class="w3-button" :disabled="!anterior">&#10094; Anterior</button>
              <button @click="buscarCaixas(++page)" class="w3-button w3-right" :disabled="!posterior">Próximo &#10095;</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import TopBar from "../../commons/TopBar.vue"
  import MenuDash from "../../commons/MenuDash.vue"

  export default {
    components: {TopBar, MenuDash},
    data() {
      return {
        token: localStorage.getItem('key'),
        page: 1,
        colaboradores: [],
        naoEcontrado: true,
        funcoes: [],

        //pesquisa
        pesquisa: {
          nome: '',
          funcao: '',
          usuario: ''
        },

        anterior: false,
        posterior: false,
      }
    },

    methods: {
      buscarColaboradores(page) {
        openLoading("Buscando Colaboradores");
        this.page = page;
        let url = base_url + 'usuarios/' + this.token + "/" + this.page;

        this.$http.get(url, {params: this.pesquisa}).then(response => {
          //console.log(response);
          if (response.data) {
            this.colaboradores = response.data.result;
            this.anterior = response.data.page > 1;
            this.posterior = response.data.page < response.data.pages;
            this.naoEcontrado = false;
          } else {
            this.caixas = [];
            this.naoEcontrado = true;
          }

          closeLoading();
        }, res => {
          console.log(res);
          closeLoading();
          openModalMsg(res.data.result,res.data.msg);
        });
      },

      buscarFuncao() {
        this.$http.get(base_url + 'funcao-usuario/' + this.token)
          .then(response => {
            console.log(response);
            this.funcoes = response.data;
            closeLoading();

          }, res => {
            closeLoading();
            openModalMsg(res.data.result,res.data.msg);
          });
      },

      limparSearch() {
        this.pesquisa = {
          nome: '',
          funcao: ''
        };
        this.buscarColaboradores(1);
      }
    },
    mounted() {
      this.buscarColaboradores(1);
      this.buscarFuncao();
    }
  }
</script>

<style scoped>
  .table-produto {
    min-height: 200px;
    position: relative;
  }

  .w3-centered tr td {
    cursor: pointer;
    padding: 13px
  }

  .w3-table td {
    vertical-align: middle;
  }
</style>



// WEBPACK FOOTER //
// src/components/admin/colaborador/AdminColaboradores.vue